import { render, staticRenderFns } from "./AsDetailForLatest.vue?vue&type=template&id=1c810189"
import script from "./AsDetailForLatest.vue?vue&type=script&lang=js"
export * from "./AsDetailForLatest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports